import dayjs from "dayjs"
import React, { Component } from "react"
import { Button, Modal } from "react-bootstrap"
import FormTaskFiller from "src/pages/dynamic_forms/FormTaskFiller/FormTaskFiller"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import InspectionApprovalDecoupler from "src/pages/fleet/Decouplers/InspectionApprovalDecoupler/InspectionApprovalDecoupler"
import MaintenanceApprovalDecoupler from "src/pages/fleet/Decouplers/MaintenanceApprovalDecoupler/MaintenanceApprovalDecoupler"
import ReviewsDecoupler from "src/pages/hr/EmployeeOverview/Decouplers/ReviewsDecoupler/ReviewsDecoupler"
import BatchUpdateApprovalDecoupler from "src/pages/batch_update_approvals/BatchUpdateApprovalDecoupler/BatchUpdateApprovalDecoupler"
import PSDecoupler from "src/pages/pto/decouplers/PSDecoupler/PSDecoupler"
import PTODecoupler from "src/pages/pto/decouplers/PTODecoupler/PTODecoupler"
import store from "src/store/store"
import mutator from "src/utilities/mutator"
import notificationStore from "../notificationStore"
import NotificationTypes from "../Types/NotificationTypes"
import "./View.css"

interface Props {
    notification: NotificationTypes | any //?? wtf
    userId: string | number
}

type Types = {
    decoupler: number
    disableControls: boolean
}

class View extends Component<Props, Types> {//bump

    decouplers = [
        { type: "review-approve", id: 0, size: "xl" },
        { type: "pto-approve", id: 1, size: "xl" },
        { type: "maintenance-approve", id: 2, size: "xl" },
        { type: "inspection-approve", id: 3, size: "xl" },
        { type: "form-task", id: 4, size: "lg" },
        { type: "process-status", id: 5, size: "md" },
        { type: "batch-update-approve", id: 6, size: "lg" }
    ]

    state = {
        decoupler: -1,
        disableControls: false
    }

    componentDidMount() {
        this.chooseDecoupler()
        const updateNotification = this.props.notification
        // Batch update tasks are completed by the approval hook in SQL. Syncing on open would
        // POST this cached copy, and the API overwrites every column from it, reverting the
        // hook's work whenever the copy predates the approve or deny.
        if (updateNotification.type !== "batch-update-approve") {
            if (!updateNotification.workFlowId) {
                notificationStore.addOrUpdateNotification([updateNotification], "read")
            } else if (!updateNotification.dateReadUtc) {
                updateNotification.dateReadUtc = dayjs.utc().format(notificationStore.timeFormat)
                notificationStore.addOrUpdateNotification([updateNotification])
            }
        }
        store.dispatch({ type: "RESET_DYNAMIC_FORM_PALETTE", payload: null })
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    chooseDecoupler = () => {
        const decouplers = this.decouplers
        for (let i = 0; i < decouplers.length; i++) {
            if (this.props.notification.type === decouplers[i].type) {
                this.setState({ decoupler: decouplers[i].id })
                return
            }
        }
        this.setState({ decoupler: 0 })
    }

    render() {

        const state = this.state
        const props = this.props
        const notification = props.notification
        const size: any = state.decoupler > -1 ? this.decouplers[state.decoupler].size : "xl"
        const bgColor = `${paletteEngine.getPaletteColor("formBackgroundColor")}`

        return (
            <div className="View">
                <Modal id={`notification-view-modal-${state.decoupler}`}
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size={size}
                >
                    <Modal.Header style={{ backgroundColor: bgColor }}>
                        <div className="ViewModalHeader">
                            <div className="ViewModalHeaderTitle">
                                <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>{notification.title}</p>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: bgColor }}>
                        {state.decoupler === -1 && <div>
                            no decoupler found
                        </div>}
                        {state.decoupler === 0 && <ReviewsDecoupler
                            //@ts-ignore
                            userId={props.userId}
                            EmployeeID={notification.linkTo.split("-")[0]}
                            ReviewID={notification.linkTo.split("-")[1]}
                            setCompleted={() => null}
                        />}
                        {state.decoupler === 1 && <div>
                            <PTODecoupler
                                EmployeeID={notification.linkTo}
                            />
                        </div>}
                        {state.decoupler === 2 && <div>
                            <MaintenanceApprovalDecoupler
                                userId={props.userId}
                                VehicleInformationId={notification.linkTo.split("-")[0]}
                                VehicleMaintenanceId={notification.linkTo.split("-")[1]}
                            />
                        </div>}
                        {state.decoupler === 3 && <InspectionApprovalDecoupler
                            userId={props.userId}
                            vehicleInformationId={notification.linkTo.split("-")[0]}
                            vehicleInspectionId={notification.linkTo.split("-")[1]}
                        />}
                        {state.decoupler === 4 && <FormTaskFiller
                            notification={notification}
                            manageParentState={this.manageState}
                        />}
                        {state.decoupler === 5 && <PSDecoupler
                            notification={notification}
                        />}
                        {state.decoupler === 6 && <BatchUpdateApprovalDecoupler
                            key={parseInt(notification.linkTo, 10)}
                            batchUpdateRequestId={parseInt(notification.linkTo, 10)}
                            userId={Number(props.userId)}
                        />}
                    </Modal.Body>
                    {!state.disableControls && <Modal.Footer style={{ backgroundColor: bgColor }}>
                        <div className="NotificationNagTaskCarouselModalFooter">
                            <Button
                                variant="secondary"
                                style={{
                                    backgroundColor: `${paletteEngine.getPaletteColor("modalWrapperbackBtnBackgroundColor")}`,
                                    color: `${paletteEngine.getPaletteColor("modalWrapperbackBtnTextColor")}`,
                                }}
                                onClick={() => notificationStore.setOpenNotification(null)}>
                                Exit
                            </Button>
                        </div>
                    </Modal.Footer>}
                </Modal>
            </div>
        )
    }
}

export default View